export default __webpack_public_path__ + "static/media/logoon-breeze.c819f047.jpg";